import React from 'react'

export const IconClaim: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M15.994 14.997c.256 0 .512-.098.706-.292l5.006-4.997-1.412-1.416-4.3 4.292-1.292-1.292-1.414 1.414 1.999 1.998C15.482 14.899 15.738 14.997 15.994 14.997zM3 20h10c.553 0 1-.447 1-1v-.5c0-2.54-1.212-4.651-3.076-5.729C11.594 12.063 12 11.1 12 10c0-2.28-1.72-4-4-4s-4 1.72-4 4c0 1.1.406 2.063 1.076 2.771C3.212 13.849 2 15.96 2 18.5V19C2 19.553 2.447 20 3 20zM6 10c0-1.178.822-2 2-2s2 .822 2 2-.822 2-2 2S6 11.178 6 10zM8 14c2.43 0 3.788 1.938 3.978 4H4.022C4.212 15.938 5.57 14 8 14z" />
    </svg>
  )
}
